
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#00001B"}},[_c('path',{attrs:{"d":"M12 2.032H0M12 6H0M12 9.968H0"}}),_c('path',{attrs:{"d":"M3.87 3.282c.696 0 1.265-.563 1.265-1.25 0-.688-.563-1.25-1.265-1.25-.703 0-1.266.562-1.266 1.25 0 .687.57 1.25 1.266 1.25zM8.726 7.25c.696 0 1.266-.563 1.266-1.25 0-.688-.57-1.25-1.266-1.25-.696 0-1.266.563-1.266 1.25 0 .688.57 1.25 1.266 1.25zM3.87 11.218c.696 0 1.265-.563 1.265-1.25s-.57-1.25-1.265-1.25c-.696 0-1.266.563-1.266 1.25 0 .688.57 1.25 1.266 1.25z","fill":"#fff"}})])])
          )
        }
      }
    